import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ErrorCode } from '../../models/error-code.model';
import { EventQueryParams } from './model/event-query-params.model';
import { Event } from './model/event.model';
import { Participant } from '../user-management/model/participant.model';
import { EventForm } from './model/event-form.model';

export const EventApiActions = createActionGroup({
    source: 'API/Event',
    events: {
        'load events': props<{ query: EventQueryParams }>(),
        'save event': props<{ event: Event; isUpdate: boolean; sendEventUpdate: boolean; updateSeries: boolean }>(),
        'load event by id': props<{ id: number }>(),
        'delete event': props<{ event: Event; deleteSeries: boolean }>(),
        'cancel event': props<{ event: Event }>(),
        'event take place': props<{ event: Event }>(),
        'move event': props<{ event: Event }>(),
        'subscribe to event': props<{ eventId: number }>(),
        'unsubscribe from event': props<{ eventId: number }>(),
        'subscribe to workshop': props<{ courseId: number }>(),
        'unsubscribe from all workshop events': props<{ courseId: number }>()
    }
});

export const EventActions = createActionGroup({
    source: 'Event',
    events: {
        'load events success': props<{ events: Event[] }>(),
        'load events failure': props<{ error: ErrorCode }>(),
        'save event success': props<{ events: Event[] }>(),
        'save event failure': props<{ error: ErrorCode }>(),
        'load event by id success': props<{ event: Event }>(),
        'load event by id failure': props<{ error: ErrorCode }>(),
        'add participant': props<{ participant: Participant }>(),
        'remove participant': props<{ index: number }>(),
        'add waitlist user': props<{ waitlistUser: Participant }>(),
        'remove waitlist user': props<{ index: number }>(),
        'set user comment': props<{ index: number; comment: string }>(),
        'delete event success': props<{ event: Event; deleteSeries: boolean }>(),
        'delete event failure': props<{ error: ErrorCode }>(),
        'cancel event success': props<{ event: Event }>(),
        'cancel event failure': props<{ error: ErrorCode }>(),
        'event take place success': props<{ event: Event }>(),
        'event take place failure': props<{ error: ErrorCode }>(),
        'move event success': props<{ event: Event }>(),
        'move event failure': props<{ error: ErrorCode }>(),
        'update selected event': props<{ values: EventForm }>(),
        'reset selected event': emptyProps(),
        'subscribe to event success': props<{ event: Event }>(),
        'subscribe to event failure': props<{ error: ErrorCode }>(),
        'unsubscribe from event success': props<{ event: Event }>(),
        'unsubscribe from event failure': props<{ error: ErrorCode }>(),
        'subscribe to workshop success': props<{ events: Event[] }>(),
        'subscribe to workshop failure': props<{ error: ErrorCode }>(),
        'unsubscribe from all workshop events success': props<{ events: Event[] }>(),
        'unsubscribe from all workshop events failure': props<{ error: ErrorCode }>()
    }
});
